import { render, staticRenderFns } from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=template&id=2c91c685&scoped=true"
import script from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"
export * from "./QuotationTableForLazyLoadingWithResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91c685",
  null
  
)

export default component.exports